module.exports = __webpack_public_path__ + "static/img/DSC02437.dc7180d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC02437.jpg
// module id = cqet
// module chunks = 0